namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem9ExemptService {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem9Exempt';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem9ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem9ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem9ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem9ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem9Exempt/Create",
            Update = "AdvPromo/PsAdvPromoItem9Exempt/Update",
            Delete = "AdvPromo/PsAdvPromoItem9Exempt/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem9Exempt/Retrieve",
            List = "AdvPromo/PsAdvPromoItem9Exempt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem9ExemptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
